(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      settings: {
        "title": "Postavke",
        "tabAccount": "NA",
        "tabNotifications": "NA",
        "tabSecurity": "NA",
        "contactInfo": "Vaši kontaktni podaci",
        "contactInfoBtn": "Promijeni",
        "contactInfoConfirmBtn": "Potvrdi",
        "contactInfoCancelBtn": "Otkaži",
        "contactInfoName": "Ime",
        "contactInfoAddress": "Adresa",
        "contactInfoPhone": "Telefon",
        "blocades": "Blokade",
        "blockLogin": "Blokiranje logiranja/logovanja u internet bankarstvo",
        "blockMobile": "Blokiranje logiranja/logovanja u mobilno bankarstvo",
        "blockPayment": "Blokiranje kartice za plaćanje",
        "accountSettings": "Postavke računa",
        "defaultAccount": "Podrazumijevani račun",
        "statementsDelivery": "Dostava izvoda",
        "statementsDeliveryPaper": "Dostava izvoda na kućnu adresu",
        "statementsDeliveryElectronic": "Dostava izvoda u putem internet bankarstva",
        "messagesSettings": "Postavke poruka",
        "messagesSettingsLabel": "Označite ako želite da sve poruke od banke primate i na email",
        "securitySettings": "Sigurnosne postavke",
        "transactionsConfirmation": "Potvrda o transakcijama",
        "transactionsConfirmationSMS": "Slanjem SMS-a na mobitel",
        "transactionsConfirmationOTP": "Generiranjem/Generisanjem jednokratne zaporke/lozinke",
        "notificationSettings": "Postavke obavještenja",
        "gsm":"GSM",
        "oldPass":"Stara lozinka",
        "newPass":"Nova lozinka",
        "againPass":"Potvrdi novu lozinku",
        "noMatch":"Pogrešna lozinka!",
        "change":"Izmijeni",
        "mothersLastName":"Djevojačko prezime majke",
        "email":"Email",
        "lengthError":" Morate unijeti najmanje 8 znakova u polje Nova lozinka !",
        "lengthOldError":" Morate unijeti najmanje 6 znakova u polje Stara lozinka !"
      }
    };

    $translateProvider.translations('bh', data);

  }
} ());
